import { render, staticRenderFns } from "./projectProRiskCanvas.vue?vue&type=template&id=10af977e&scoped=true&"
import script from "./projectProRiskCanvas.vue?vue&type=script&lang=js&"
export * from "./projectProRiskCanvas.vue?vue&type=script&lang=js&"
import style0 from "./projectProRiskCanvas.vue?vue&type=style&index=0&id=10af977e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af977e",
  null
  
)

export default component.exports